import { useEffect } from "react";
import { flushSync } from "react-dom";

import type { ImpulseForm } from "~/tools/impulse-form";
import { useHandler } from "~/tools/use-handler";

export function usePropagateFocusWhenInvalid<TForm extends ImpulseForm>(
	form: undefined | TForm,
	beforePropagate: VoidFunction,
): void {
	const beforePropagateStable = useHandler(beforePropagate);

	useEffect(() => {
		return form?.onFocusWhenInvalid(() => {
			// enforce the component to re-render
			flushSync(() => beforePropagateStable());

			// at this point the component with invalid fields should already expand further and register new focus handler
			form.focusFirstInvalid();
		});
	}, [form, beforePropagateStable]);
}
